
import { getFacilityId } from '../utils/format';
const API_BASE_URL = "https://backend.profitconnect.co/crm"; // Base URL for your API
const API_BASE_URL_NEW = "https://crmapi.profitconnect.co"

// API Endpoints
const API = {
  GET_STUDIOS:`${API_BASE_URL}/Facility/getStudio`,
  GET_MEMBERS: `${API_BASE_URL_NEW}/members/get/members`,
  VALIDATE_MEMBER_BOOKING: `${API_BASE_URL_NEW}/member/booking/validate`,
  BOOK_MEMBER: `${API_BASE_URL_NEW}/member/booking/book`,
  GET_CATEGORIES:`${API_BASE_URL_NEW}/space/get/spaces`,
  GET_DAY_SCHEDULE:`${API_BASE_URL_NEW}/calendar/get/dayschedule`,
  CHECKIN_MEMBER:`${API_BASE_URL_NEW}/member/booking/checkin`,
  PRE_POST_ORDER:`${API_BASE_URL}/PrePostOrders/payForOrders`,
  UPDATE_CHECKIN_COUNT:`${API_BASE_URL}/Kiosk/get/counts`
 
 
};

// Facility ID - Example
const FACILITY_ID = getFacilityId(); // Default Facility ID, change if needed
const BOOK_STATUS = {
    BOOKED: "Booked",
    WAITING: "Waiting",
  };

export { API_BASE_URL,API, FACILITY_ID,BOOK_STATUS };

